import * as React from "react";
import { forwardRef } from "react";
const SvgGroundTruthChevronDivider = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 33, height: 100, viewBox: "0 0 33 100", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.73828 0.992188L29.7383 49.9922L1.73828 98.9922", stroke: "#182231", strokeWidth: 4 }));
const ForwardRef = forwardRef(SvgGroundTruthChevronDivider);
export { ForwardRef as ReactComponent };
